import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { ref, computed } from 'vue'
import {
  roadAreaConfigList,
  deleteRoadAreaConfig
} from '@/api/yuntuSales/roadAreaConfig'
import { listByParamCodes } from '@/api/common'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { Modal as AModal } from 'ant-design-vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
const __default__ = { name: 'DcCosLbuRoadAreaConfig' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref<{ toggle: (row?: any) => void }>()

const tableRef = ref()
const queryForm = ref({})
// 获取列表
const fetch = async (params: any, callBack: (res: any) => void) => {
  try {
    const res = await roadAreaConfigList({ ...params })
    callBack(res)
  } catch (error) {
    console.log('fetcherror: ', error)
  }
}

const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  { title: '路区代码', dataIndex: 'roadAreaCode' },
  { title: '查看人', dataIndex: 'employeeNo' },
  { title: '更新人', dataIndex: 'updateBy' },
  { title: '更新时间', dataIndex: 'updateTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: any) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: any) => {
  Modal.delete({
    name: row.deptName,
    onOk() {
      deleteRoadAreaConfig({id: row.id}).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm.value,
            "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm).value = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuRoadAreaConfig"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "deptIdList",
                    label: "路区代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(RoadAreaSelect, {
                        update: "roadAreaCode",
                        value: queryForm.value.roadAreaCode,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.roadAreaCode) = $event)),
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "deptScopeId",
                    label: "查看人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.value.employeeNo,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.employeeNo) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'roadAreaCode')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(record.roadAreaCode.join(',')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'employeeNo')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(`${record.userName}(${record.employeeNo})`), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'updateBy')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(`${record.updateByName}(${record.updateBy})`), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 3 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_road_area_config_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_road_area_config_delete_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_road_area_config_add_btn']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})